import { zYesno } from '@/utils';
import { z } from 'zod';
import { zLookup } from '@/utils/zodHelper';

export const CountrySchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  is_active: z.boolean().optional(),
  region: zLookup(),
});

export const CountrySearchSchema = z.object({
  search: z.string().optional(),
  is_active: zYesno().optional(),
});

export type CountrySchemaType = z.infer<typeof CountrySchema>;
